import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Sparkles, Lock } from 'lucide-react';
import { fadeIn } from './shared';

const ITEMS = [
  { Icon: Zap, label: '10 seconds score preview' },
  { Icon: Lock, label: 'No Auto-pay' },
  { Icon: ShieldCheck, label: 'GDPR & UK PECR compliant' },
  { Icon: Sparkles, label: 'Voice-matched, not generic' },
];

export const MarqueeStrip = () => (
  <motion.section
    {...fadeIn}
    aria-label="Trust strip"
    className="relative border-y border-border/60 bg-[hsl(var(--ep-surface-2,215_25%_97%))]/60 backdrop-blur-sm"
    data-testid="landing-marquee-strip"
  >
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-5">
      <ul className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-xs sm:text-[13px] text-muted-foreground">
        {ITEMS.map(({ Icon, label }) => (
          <li key={label} className="inline-flex items-center gap-2">
            <Icon size={14} className="text-primary/80" aria-hidden="true" />
            <span className="tracking-tight">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  </motion.section>
);
